import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/cal.com/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
